/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow, Checkbox } from "@mui/material";
import { Formik } from "formik";
import React, { useContext, useMemo, useState, useRef } from "react";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import OrganisationStructure from "../components/OrganisationSearch";
import styles from "./BulkTransfer.styles";
import CustomTable from "../../../../components/common/new/Table/Table";
import {
  convertToId,
  toCapitalize,
  convertToName,
  isEmptyObj,
} from "../../../../utils/helper";
import tableStyle from "../../../../theme/styles/table";
import { ORGANIZATION_STRUCTURE_FIELDS } from "../../../../contants/formFields";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import {
  AlertStatus,
  OS_DROPDOWN_KEYS,
  FULL_OS_KEYS,
  Constants,
} from "../../../../contants";
import Member from "../../../../services/api/member";
import Friend from "../../../../services/api/friend";
import Appointment from "../../../../services/api/appointment";
import {
  SPLIT_API_MAPPER,
  STRUCTURE_PARENT_MAPPER,
} from "../../../../contants/appointment";
import {
  BULK_TRANSFER_MEMBER_TABLE,
  BULK_TRANSFER_TABLE,
} from "../../../../contants/table/bulkTransfer";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
  selectUserProfile,
} from "../../../../redux/selectors/user";
import Pagination from "../../../../components/common/new/Pagination/Pagination";
// import { Constants } from "../../../../contants/index";
import Loader from "../../../../components/common/Loader/Loader";

const OS_LABEL = "organisationStructure";
const SPLIT_LEVEL_KEY = "hierarchy";
const GENERIC_FORM_ERROR = "Please enter valid inputs";
const MEMBER = "MEMBER";
const FRIEND = "FRIEND";

const OPTIONS = [
  { value: "CLUSTER", label: "Cluster Level" },
  { value: "ZONE", label: "Zone Level" },
  { value: "REGION", label: "Region Level" },
  { value: "CHAPTER", label: "Chapter Level" },
  { value: "DISTRICT", label: "District Level" },
  { value: "BLOCK", label: "Block Level" },
  { value: MEMBER, label: "Member Level" },
  { value: FRIEND, label: "Friend Level" },
];

const FORM_FIELD_NAMES = {
  AREA: "areaId_to",
  CLUSTER: "clusterId_to",
  ZONE: "zoneId_to",
  REGION: "regionId_to",
  CHAPTER: "chapterId_to",
  DISTRICT: "districtId_to",
  BLOCK: "blockId_to",
};
const intialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: Constants.DEFAULT_PAGE_SIZE,
};

const getOSValues = (osKeys, values) =>
  osKeys.reduce((acc, key) => {
    if (values[key]) {
      return Object.assign(acc, { [key]: values[key] });
    }
    return acc;
  }, {});

const getApiAndPayload = ({ hierarchy, ...rest }) => {
  if (hierarchy === MEMBER) {
    return {
      api: Member.search,
      payload: {
        [OS_LABEL]: getOSValues(FULL_OS_KEYS, rest),
      },
    };
  }
  if (hierarchy === FRIEND) {
    return {
      api: Friend.searchBulkFriend,
      payload: getOSValues(FULL_OS_KEYS, rest),
    };
  }

  const parentChief = STRUCTURE_PARENT_MAPPER[hierarchy];
  const parentKeyId = convertToId(parentChief);
  return {
    api: SPLIT_API_MAPPER[parentChief],
    payload: {
      data: {
        [parentKeyId]: Number(rest[parentKeyId]),
      },
    },
  };
};

const getParentId = (values) => {
  let parentId = "";
  for (const key of Object.values(FORM_FIELD_NAMES)) {
    if (!values[key]) {
      break;
    }
    parentId = values[key];
  }
  return parentId;
};

const isMemberOrFriendRole = (hierarchy) =>
  [MEMBER, FRIEND].includes(hierarchy);

const isOrganisationStructureValid = (values, keys) => {
  const { hierarchy } = values;
  let isValid = true;
  for (const key of keys) {
    const keyName = convertToName(key);
    if (hierarchy === keyName) break;
    if (hierarchy !== keyName && !values[key]) {
      isValid = false;
      break;
    }
  }
  return isValid;
};

const isFormValid = (values) => {
  if (isEmptyObj(values)) return false;
  if (!values[SPLIT_LEVEL_KEY]) return false;

  return isOrganisationStructureValid(values, [...FULL_OS_KEYS].reverse());
};

const isFinalFormValid = (values) => {
  if (!isFormValid(values)) return false;
  if (!values[FORM_FIELD_NAMES.AREA]) return false;
  if (!values.selectedList || !values.selectedList.length) return false;

  return isOrganisationStructureValid(values, Object.values(FORM_FIELD_NAMES));
};

function RadioInput({ selectedOption, handleChange, option }) {
  return (
    <label key={option.value} style={styles.radioLabel}>
      <input
        type="radio"
        name={SPLIT_LEVEL_KEY}
        value={option.value}
        checked={selectedOption === option.value}
        onChange={handleChange}
        style={{ marginRight: "8px", cursor: "pointer" }}
      />
      {option.label}
    </label>
  );
}

const getRows = ({ list, selectedList, selectionHandler, hierarchy }) =>
  list.map((item) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ width: "1rem", padding: "16px" }}>
        <Checkbox
          checked={selectedList.includes(item.id)}
          onChange={(e) => selectionHandler(e.target.checked, item.id)}
        />
      </TableCell>
      <TableCell style={{ color: "#043D90", fontWeight: "600" }}>
        {item.id}
      </TableCell>
      <TableCell>{item.name}</TableCell>
      {(hierarchy === FRIEND || hierarchy === MEMBER) && (
        <>
          <TableCell>{item.divisionName}</TableCell>
          <TableCell>{item.address}</TableCell>
        </>
      )}
    </TableRow>
  ));

const formatList = (data, hierarchy) => {
  if (hierarchy === MEMBER) {
    return data.content.map((d) => ({
      id: d.memberId,
      name: d.fullName,
      divisionName: d.divisionName,
      address: d.addressLine1,
    }));
  }
  if (hierarchy === FRIEND) {
    return data?.map((d) => ({
      id: d.friendId,
      name: d.fullName,
      divisionName: d.divisionName,
      address: d.addressLine1,
    }));
  }
  return data?.map((d) => ({
    id: d.structureId,
    name: d.name,
  }));
};

function BulkTransfer() {
  const [isLevelSelected, setIsLevelSelected] = useState(false);
  const [hierarchy, setHierarchy] = useState(null);
  const [list, setList] = useState(null);
  const [selectedList, setSelectedList] = useState([]);
  const toast = useContext(ToastAlertContext);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const userData = useSelector(selectUserProfile);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const formRef = useRef(null);
  const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);

  const disablesOSKeysForToForm = disabledOSKeys?.length
    ? disabledOSKeys.map((key) => `${key}_to`)
    : [];

  const preselectOSKeys = () => {
    if (disabledOSKeys?.length && !isEmptyObj(userData)) {
      return disabledOSKeys.reduce(
        (acc, key) => ({
          ...acc,
          [key]: userData[key] || "",
          ...(!isHelpDesk ? { [`${key}_to`]: userData[key] || "" } : {}),
          ...(!isHelpDeskAdmin ? { [`${key}_to`]: userData[key] || "" } : {}),
        }),
        {}
      );
    }
    return {};
  };

  const selectionHandler = (value, itemId) => {
    if (value) {
      setSelectedList((prev) => [...prev, itemId]);
    } else {
      setSelectedList((prev) => prev.filter((id) => id !== itemId));
    }
  };

  const checkAllToggle = (checked) => {
    if (checked) {
      setSelectedList(list.map((item) => item.id));
    } else {
      setSelectedList([]);
    }
  };
  const updatePaginationInfo = (pagination) => {
    setPaginationInfo({
      currentPage: pagination.number,
      totalPages: pagination.totalPages,
      totalElements: pagination.totalElements,
      pageSize: pagination.size,
    });
  };

  const onLevelSubmit = async (values, { setSubmitting }) => {
    try {
      const formValues = { ...values, hierarchy };
      if (!isFormValid(formValues)) {
        throw new Error(GENERIC_FORM_ERROR);
      }
      const paginationParams = {
        pageSize: Constants.DEFAULT_PAGE_SIZE,
        page: 0,
      };

      const { api, payload } = getApiAndPayload(formValues);
      // const response = await api(payload, paginationParams);
      // const { data, content } = await api(payload, paginationParams);
      const response = await api(payload, paginationParams);
      const { data, content } = response;

      setList(formatList(data || content, hierarchy));
      const paginationData = data ?? response;
      updatePaginationInfo(paginationData);
      setIsLevelSelected(true);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setSubmitting && setSubmitting(false);
    }
  };

  const resetForm = () => {
    setHierarchy(null);
    formRef.current.resetForm();
  };

  const onCancel = () => {
    setList([]);
    setSelectedList([]);
    resetForm();
    setIsLevelSelected(false);
  };

  const onFinalSubmit = async (values, { setSubmitting }) => {
    try {
      const formValues = { ...values, hierarchy, selectedList };
      if (!isFinalFormValid(formValues)) {
        throw new Error(GENERIC_FORM_ERROR);
      }

      const parentId = getParentId(values);
      const payload = {
        hierarchy: isMemberOrFriendRole(hierarchy) ? "BLOCK" : hierarchy,
        ...(isMemberOrFriendRole(hierarchy)
          ? {
              userType: hierarchy,
              memberFriendIds: selectedList,
            }
          : {
              structureIds: selectedList,
            }),
      };

      await Appointment.updateSplitStructure({ data: payload, parentId });
      toast.show("Successfully transferred", AlertStatus.SUCCESS);
      setTimeout(onCancel, 3000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setSubmitting(false);
    }
  };

  const onFormSubmit = (...args) => {
    if (!isLevelSelected) {
      onLevelSubmit(...args);
    } else {
      onFinalSubmit(...args);
    }
  };

  const restFormStateForOS = (setFieldValue) => {
    Object.values(ORGANIZATION_STRUCTURE_FIELDS).forEach((key) => {
      if (!disabledOSKeys.includes(key)) {
        setFieldValue(key, "");
      }
    });
  };

  const getDisabledKeys = (osKeys) => {
    if (!hierarchy) return [];
    if (isMemberOrFriendRole(hierarchy)) return [];

    const disableKeys = [];
    for (const key of osKeys.slice().reverse()) {
      const newKey = convertToName(key);
      disableKeys.push(key);
      if (newKey === hierarchy) {
        break;
      }
    }

    return disableKeys;
  };

  const fromDisabledKeys = useMemo(
    () => getDisabledKeys(OS_DROPDOWN_KEYS),
    [hierarchy]
  );

  const toDisabledKeys = useMemo(
    () => getDisabledKeys(Object.values(FORM_FIELD_NAMES)),
    [hierarchy]
  );

  const tableColumns = useMemo(() => {
    if (hierarchy && isMemberOrFriendRole(hierarchy)) {
      return BULK_TRANSFER_MEMBER_TABLE.with(1, {
        displayName: hierarchy === MEMBER ? "Member Id" : "Friend Id",
        key: "id",
      });
    }
    if (hierarchy) {
      return BULK_TRANSFER_TABLE.with(1, {
        displayName: `${toCapitalize(hierarchy)} Id`,
        key: "id",
      });
    }
    return BULK_TRANSFER_TABLE;
  }, [hierarchy]);

  const getOptions = (options) =>
    isHelpDesk || isHelpDeskAdmin
      ? options
      : options.filter(
          (opt) =>
            !["REGION", "CLUSTER", "ZONE", "CHAPTER", "DISTRICT"].includes(
              opt.value
            )
        );
  const onPaginationClick = async (pageNumber) => {
    try {
      setIsLoading(true);
      const formValues = formRef.current.values;
      let paginationParams = {
        pageSize: paginationInfo.pageSize,
        page: pageNumber,
      };
      if (hierarchy === MEMBER) {
        paginationParams = {
          pageSize: paginationInfo.pageSize,
          page: pageNumber,
        };
      }
      if (hierarchy === FRIEND) {
        paginationParams = {
          pageSize: paginationInfo.pageSize,
          pageNumber,
        };
      }

      const { api, payload } = getApiAndPayload({ ...formValues, hierarchy });

      const response = await api(payload, paginationParams);
      const { data, content } = response;

      setList(formatList(data || content, hierarchy));

      const paginationData = data ?? response;
      updatePaginationInfo(paginationData);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      setIsLoading(false);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onPageSizeClick = async (action) => {
    try {
      setIsLoading(true);
      const pageSizes = [10, 15, 20];
      const currentSizeIndex = pageSizes.indexOf(paginationInfo.pageSize);

      let newSizeIndex = 0;

      if (action === "plus") {
        newSizeIndex = (currentSizeIndex + 1) % pageSizes.length;
      } else if (action === "subtract") {
        newSizeIndex = (currentSizeIndex - 1) % pageSizes.length;
      }

      const newPageSize = pageSizes[newSizeIndex];

      const formValues = formRef.current.values;
      // const currentPageNumber = paginationInfo.currentPage;
      const paginationParams = {
        pageSize: newPageSize,
        // page: currentPageNumber,
      };

      const { api, payload } = getApiAndPayload({ ...formValues, hierarchy });

      const response = await api(payload, paginationParams);
      const { data, content } = response;

      setList(formatList(data || content, hierarchy));

      const paginationData = data ?? response;
      updatePaginationInfo(paginationData);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      setIsLoading(false);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  const requiredOSKeys = useMemo(() => {
    if (!hierarchy) return [ORGANIZATION_STRUCTURE_FIELDS.AREA];
    if (isMemberOrFriendRole(hierarchy)) return OS_DROPDOWN_KEYS;

    const keyId = convertToId(hierarchy);
    const targetIndex = OS_DROPDOWN_KEYS.findIndex((key) => key === keyId);

    return OS_DROPDOWN_KEYS.slice(0, targetIndex);
  }, [hierarchy]);

  const requiredOSKeysForTo = useMemo(() => {
    if (isLevelSelected) {
      const fieldKeyForTO = Object.values(FORM_FIELD_NAMES);

      if (!hierarchy) return [ORGANIZATION_STRUCTURE_FIELDS.AREA];
      if (isMemberOrFriendRole(hierarchy)) return fieldKeyForTO;

      const keyId = `${convertToId(hierarchy)}_to`;
      const targetIndex = fieldKeyForTO.findIndex((key) => key === keyId);

      return fieldKeyForTO.slice(0, targetIndex);
    }
    return [ORGANIZATION_STRUCTURE_FIELDS.AREA];
  }, [hierarchy, isLevelSelected]);

  return (
    <Box style={styles.container}>
      <Formik
        initialValues={preselectOSKeys()}
        onSubmit={onFormSubmit}
        innerRef={formRef}
        enableReinitialize
      >
        {({
          values,
          errors,
          handleChange,
          setFieldValue,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box style={styles.main}>
              {!isLevelSelected && (
                <Box style={styles.leftMain}>
                  <Typography variant="small" weight={600} color="#4E4E4E">
                    Select Bulk Transfer Level
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box style={styles.inputWrapper}>
                    {!isLevelSelected ? (
                      <>
                        {getOptions(OPTIONS).map((option) => (
                          <RadioInput
                            option={option}
                            handleChange={(e) => {
                              restFormStateForOS(setFieldValue);
                              setHierarchy(e.target.value);
                            }}
                            selectedOption={hierarchy}
                          />
                        ))}
                      </>
                    ) : (
                      <div>From</div>
                    )}
                  </Box>
                </Box>
              )}
              <Box style={styles.rightMain}>
                <Typography variant="small" weight={600} color="#4E4E4E">
                  Bulk Transfer Level (From)
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <Box
                  style={{ ...styles.inputWrapper, backgroundColor: "#FFF3F3" }}
                >
                  <OrganisationStructure
                    values={values}
                    errors={errors}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    showBlock
                    containerStyle={{ display: "flex" }}
                    disabledOSKeys={
                      isLevelSelected
                        ? disabledOSKeys.concat(FULL_OS_KEYS)
                        : disabledOSKeys.concat(fromDisabledKeys)
                    }
                    requiredOSKeys={requiredOSKeys}
                    // hiddenFields={hiddenOsFields}
                  />
                </Box>
              </Box>
              {isLevelSelected && (
                <Box style={styles.rightMain}>
                  <Typography variant="small" weight={600} color="#4E4E4E">
                    Bulk Transfer Level (To)
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Box
                    style={{
                      ...styles.inputWrapper,
                      backgroundColor: "#FFF3F3",
                    }}
                  >
                    <OrganisationStructure
                      values={values}
                      errors={errors}
                      showBlock
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      containerStyle={{ display: "flex" }}
                      formFieldNames={FORM_FIELD_NAMES}
                      disabledOSKeys={
                        !isHelpDesk || !isHelpDeskAdmin
                          ? disablesOSKeysForToForm.concat(toDisabledKeys)
                          : toDisabledKeys
                      }
                      requiredOSKeys={requiredOSKeysForTo}
                      // hiddenFields={hiddenOsFields}
                    />
                  </Box>
                </Box>
              )}
            </Box>
            <Box style={styles.btnContainer}>
              <Button label="Submit" type="submit" isLoading={isSubmitting} />
              {isLevelSelected ? (
                <Button label="Cancel" onClick={onCancel} variant="outlined" />
              ) : null}
            </Box>
          </form>
        )}
      </Formik>
      {list && list.length > 0 && (
        <Box style={styles.tableContainer}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body" color="#8C8C8C" weight={600}>
              {toCapitalize(hierarchy)} Details
            </Typography>
            {(hierarchy === MEMBER || hierarchy === FRIEND) && (
              <Typography variant="body" weight={500}>
                Total {toCapitalize(hierarchy)}s: {paginationInfo.totalElements}
              </Typography>
            )}
          </Box>

          <CustomTable
            checkAllToggle={checkAllToggle}
            columnCellStyle={{ textAlign: "left" }}
            scrollable
            columns={tableColumns}
            rows={getRows({
              list,
              selectedList,
              selectionHandler,
              hierarchy,
            })}
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{
              ...styles.tableHeadCells,
              // textAlign: "left",
            }}
          />
          {hierarchy === MEMBER || hierarchy === FRIEND ? (
            <div style={styles.pagination}>
              <Pagination
                totalPages={paginationInfo.totalPages}
                totalResults={paginationInfo.totalElements}
                currentPage={paginationInfo.currentPage}
                pageSize={paginationInfo.pageSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </div>
          ) : null}
        </Box>
      )}
      {isLevelSelected && list.length === 0 && (
        <Box mt={8}>
          <Typography component="p" variant="title1" align="center">
            No Result
          </Typography>
        </Box>
      )}
      {isLoading && <Loader />}
    </Box>
  );
}

export default BulkTransfer;
